import type { CourseRegistrationManagementDetailsViewModel } from '@/shared/api/generated';
import { useGetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab } from '@/shared/api/generated';

/**
 * Hook para carregar o resumo da aba "Detalhes" de uma matrícula.
 *
 * @param courseRegistrationId - ID da matrícula (path param do backend)
 */
export function useEnrollmentDetails(courseRegistrationId: number) {
  const query =
    useGetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab(courseRegistrationId);

  const details: CourseRegistrationManagementDetailsViewModel | undefined = query.data;

  return {
    details,
    isLoading: query.isLoading,
    isError: query.isError,
    isRefetching: query.isRefetching,
    refetch: query.refetch,
  } as const;
}
